import React from "react";

const BannerAudit = ({ banner }) => {

  return (
    <>
        <article
          id="banner-pub"
          className="institucional__bg-start bg-fullpage foto my-3"
          aria-label="Presentación de Institucional de Tensolite"

        >
          <picture>
            <source
              media="(orientation: portrait) and (max-width: 767px)"
              srcSet={
                banner.image_tablet
                  ? banner.image_tablet[0]?.url
                  : banner.image_tablet
              }
              alt={
                banner.image_tablet
                  ? banner.image_tablet[0]?.alt
                  : banner?.title
              }
              className="img-responsive height-banner"
              title={banner?.title}
            />
            <source
              media="(orientation: landscape) and (max-width: 767px)"
              srcSet={
                banner.image_desktop
                  ? banner.image_desktop[0]?.url
                  : banner.image_desktop
              }
              alt={
                banner.image_desktop
                  ? banner.image_desktop[0]?.alt
                  : banner?.title
              }
              className="img-responsive height-banner"
              title={banner?.title}
            />
            <img
              className="img-responsive height-banner"
              src={
                banner.image_desktop
                  ? banner.image_desktop[0]?.url
                  : banner.image_desktop
              }
              alt={
                banner.image_desktop
                  ? banner.image_desktop[0]?.alt
                  : banner?.title
              }
              title={banner?.title}
            />
          </picture>
          <div className="card-info mb-4">
            <div className="cuadrado-azul"></div>
            <p className="parrafo-tecnico">{banner?.body}</p>
            <button className="settings_button-pleno bg-p-primary_2">
              <a href={banner?.link}>Contacto</a>
            </button>
          </div>
        </article>
    </>
  );
};

export default BannerAudit;
